import { useState } from 'react';
import abstractMark1 from '../../images/portfolio/Abstract Mark/logos-1.jpg';
import abstractMark2 from '../../images/portfolio/Abstract Mark/logos-2.jpg';
import abstractMark3 from '../../images/portfolio/Abstract Mark/logos-3.jpg';
import abstractMark4 from '../../images/portfolio/Abstract Mark/logos-4.jpg';
import abstractMark5 from '../../images/portfolio/Abstract Mark/logos-5.jpg';
import abstractMark6 from '../../images/portfolio/Abstract Mark/logos-6.jpg';
import acombinationMark1 from '../../images/portfolio/Combination Mark/logos-1.jpg';
import acombinationMark2 from '../../images/portfolio/Combination Mark/logos-2.jpg';
import acombinationMark3 from '../../images/portfolio/Combination Mark/logos-3.jpg';
import acombinationMark4 from '../../images/portfolio/Combination Mark/logos-4.jpg';
import acombinationMark5 from '../../images/portfolio/Combination Mark/logos-5.jpg';
import letterMark1 from '../../images/portfolio/Letter Mark/logos-1.jpg';
import letterMark2 from '../../images/portfolio/Letter Mark/logos-2.jpg';
import letterMark3 from '../../images/portfolio/Letter Mark/logos-3.jpg';
import letterMark4 from '../../images/portfolio/Letter Mark/logos-4.jpg';
import letterMark5 from '../../images/portfolio/Letter Mark/logos-5.jpg';
import letterMark6 from '../../images/portfolio/Letter Mark/logos-6.jpg';
import mascot1 from '../../images/portfolio/Mascot logo/logos-01.jpg';
import mascot2 from '../../images/portfolio/Mascot logo/logos-02.jpg';
import mascot3 from '../../images/portfolio/Mascot logo/logos-03.jpg';
import mascot4 from '../../images/portfolio/Mascot logo/logos-04.jpg';
import mascot5 from '../../images/portfolio/Mascot logo/logos-05.jpg';
import mascot6 from '../../images/portfolio/Mascot logo/logos-06.jpg';
import pictorialMark1 from '../../images/portfolio/Pictorial Mark Logo/logos-1.jpg';
import pictorialMark2 from '../../images/portfolio/Pictorial Mark Logo/logos-2.jpg';
import pictorialMark3 from '../../images/portfolio/Pictorial Mark Logo/logos-3.jpg';
import pictorialMark4 from '../../images/portfolio/Pictorial Mark Logo/logos-4.jpg';
import pictorialMark5 from '../../images/portfolio/Pictorial Mark Logo/logos-5.jpg';
import pictorialMark6 from '../../images/portfolio/Pictorial Mark Logo/logos-6.jpg';
import wordMark1 from '../../images/portfolio/Word mark Logo/logos-1.jpg';
import wordMark2 from '../../images/portfolio/Word mark Logo/logos-2.jpg';
import wordMark3 from '../../images/portfolio/Word mark Logo/logos-3.jpg';
import wordMark4 from '../../images/portfolio/Word mark Logo/logos-4.jpg';
import wordMark5 from '../../images/portfolio/Word mark Logo/logos-5.jpg';
import wordMark6 from '../../images/portfolio/Word mark Logo/logos-6.jpg';


const teamData = {
    abstractMark: [
        {
            avatar: abstractMark1,
        },
        {
            avatar: abstractMark2,
        },
        {
            avatar: abstractMark3,
        },
        {
            avatar: abstractMark4,
        },
        {
            avatar: abstractMark5,
        },
        {
            avatar: abstractMark6,
        },
    ],
    combinationMark: [
        {
            avatar: acombinationMark1,
        },
        {
            avatar: acombinationMark2,
        },
        {
            avatar: acombinationMark3,
        },
        {
            avatar: acombinationMark4,
        },
        {
            avatar: acombinationMark5,
        },
    ],
    letterMark: [
        {
            avatar: letterMark1,
        },
        {
            avatar: letterMark2,
        },
        {
            avatar: letterMark3,
        },
        {
            avatar: letterMark4,
        },
        {
            avatar: letterMark5,
        },
        {
            avatar: letterMark6,
        },
    ],
    mascot: [
        {
            avatar: mascot1,
        },
        {
            avatar: mascot2,
        },
        {
            avatar: mascot3,
        },
        {
            avatar: mascot4,
        },
        {
            avatar: mascot5,
        },
        {
            avatar: mascot6,
        },
    ],
    pictorialMark: [
        {
            avatar: pictorialMark1,
        },
        {
            avatar: pictorialMark2,
        },
        {
            avatar: pictorialMark3,
        },
        {
            avatar: pictorialMark4,
        },
        {
            avatar: pictorialMark5,
        },
        {
            avatar: pictorialMark6,
        },
    ],
    wordMark: [
        {
            avatar: wordMark1,
        },
        {
            avatar: wordMark2,
        },
        {
            avatar: wordMark3,
        },
        {
            avatar: wordMark4,
        },
        {
            avatar: wordMark5,
        },
        {
            avatar: wordMark6,
        },
    ],
};

const TeamSection = () => {
    const [activeTab, setActiveTab] = useState('abstractMark'); // Default active tab

    const handleTabChange = (tab) => {
        setActiveTab(tab);
    };

    const renderTeamMembers = (team) => {
        return team.map((member, index) => (
            <div key={index} className="col-lg-3 col-md-6 col-sm-6">
                <div className="ico_team_block">
                    <div className="ico_team_block_inner">
                        <div className="front_side_content">
                            <img src={member.avatar} alt={member.name} />
                        </div>
                        <div className="back_side_content">
                            <img src={member.avatar} alt={member.name} />
                        </div>
                    </div>
                </div>
            </div>
        ));
    };

    return (
        <section id="id_ico_team_section" className="ico_team_section section_decoration section_space">
            <div className="container">
                <div className="ico_heading_block text-center" data-aos="fade-up" data-aos-duration="800">
                    <h2 className="heading_text mb-0">Our Logo Designs</h2>
                </div>

                <div className="tab_block" data-aos="fade-up" data-aos-duration="800" data-aos-delay="100">
                    <div className="d-flex justify-content-center">
                        <ul className="nav unordered_list justify-content-md-center" role="tablist">
                            <li className="nav-item" role="presentation">
                                <button
                                    className={`nav-link ${activeTab === 'abstractMark' ? 'active' : ''}`}
                                    onClick={() => handleTabChange('abstractMark')}
                                    type="button"
                                    role="tab"
                                >
                                    Abstract Mark
                                </button>
                            </li>
                            <li className="nav-item" role="presentation">
                                <button
                                    className={`nav-link ${activeTab === 'combinationMark' ? 'active' : ''}`}
                                    onClick={() => handleTabChange('combinationMark')}
                                    type="button"
                                    role="tab"
                                >
                                    Combination Mark
                                </button>
                            </li>
                            <li className="nav-item" role="presentation">
                                <button
                                    className={`nav-link ${activeTab === 'letterMark' ? 'active' : ''}`}
                                    onClick={() => handleTabChange('letterMark')}
                                    type="button"
                                    role="tab"
                                >
                                    Letter Mark
                                </button>
                            </li>
                            <li className="nav-item" role="presentation">
                                <button
                                    className={`nav-link ${activeTab === 'mascot' ? 'active' : ''}`}
                                    onClick={() => handleTabChange('mascot')}
                                    type="button"
                                    role="tab"
                                >
                                    Mascot
                                </button>
                            </li>
                            <li className="nav-item" role="presentation">
                                <button
                                    className={`nav-link ${activeTab === 'pictorialMark' ? 'active' : ''}`}
                                    onClick={() => handleTabChange('pictorialMark')}
                                    type="button"
                                    role="tab"
                                >
                                    Pictorial Mark
                                </button>
                            </li>
                            <li className="nav-item" role="presentation">
                                <button
                                    className={`nav-link ${activeTab === 'wordMark' ? 'active' : ''}`}
                                    onClick={() => handleTabChange('wordMark')}
                                    type="button"
                                    role="tab"
                                >
                                    Word Mark
                                </button>
                            </li>
                        </ul>
                    </div>

                    <div className="tab-content">
                        <div className={`tab-pane fade ${activeTab === 'abstractMark' ? 'show active' : ''}`} role="tabpanel">
                            <div className="row justify-content-center">{renderTeamMembers(teamData.abstractMark)}</div>
                        </div>
                        <div className={`tab-pane fade ${activeTab === 'combinationMark' ? 'show active' : ''}`} role="tabpanel">
                            <div className="row justify-content-center">{renderTeamMembers(teamData.combinationMark)}</div>
                        </div>
                        <div className={`tab-pane fade ${activeTab === 'letterMark' ? 'show active' : ''}`} role="tabpanel">
                            <div className="row justify-content-center">{renderTeamMembers(teamData.letterMark)}</div>
                        </div>
                        <div className={`tab-pane fade ${activeTab === 'mascot' ? 'show active' : ''}`} role="tabpanel">
                            <div className="row justify-content-center">{renderTeamMembers(teamData.mascot)}</div>
                        </div>
                        <div className={`tab-pane fade ${activeTab === 'pictorialMark' ? 'show active' : ''}`} role="tabpanel">
                            <div className="row justify-content-center">{renderTeamMembers(teamData.pictorialMark)}</div>
                        </div>
                        <div className={`tab-pane fade ${activeTab === 'wordMark' ? 'show active' : ''}`} role="tabpanel">
                            <div className="row justify-content-center">{renderTeamMembers(teamData.wordMark)}</div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default TeamSection;